// extracted by mini-css-extract-plugin
export default {"clamped3":"styles---clamped3---FRGH6","clamped5":"styles---clamped5---wP7lh"};